// In tests, this file is mocked and values are in "tests/setup"
export const getEnv = (name: string): string | undefined => import.meta.env[name];
